// @ts-nocheck
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import FormsProvider from "./context/forms/FormsProvider"
import { BrowserRouter } from "react-router-dom";
import { I18nProvider } from "./i18n/I18nContext";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <I18nProvider>
        <FormsProvider>
          <App />
        </FormsProvider>
      </I18nProvider>
    </BrowserRouter>
  </React.StrictMode>
);
